/*
 * Menu-Bag (Figma node 532:14276) — quantidade/remoção no hover-panel do
 * ícone da sacola no header (sections/header.liquid + snippets/
 * zakra-header-bag-menu.liquid). Segue o mesmo padrão de renderização de
 * seções que assets/cart.js já usa em CartItems.updateQuantity: chama
 * /cart/change.js pedindo a seção "header" de volta e substitui o wrapper
 * inteiro (#zkr-header-bag-wrapper) pelo HTML atualizado, em vez de
 * recalcular totais/parcelamento em JS — o Liquid em
 * zakra-header-bag-menu.liquid continua sendo a única fonte de verdade
 * para o preço "cartão"/PIX.
 */
function initZakraHeaderBag() {
  var wrapper = document.getElementById('zkr-header-bag-wrapper');
  var closeTimer = null;
  if (!wrapper) return;

  function setWrapper(nextWrapper) {
    wrapper = nextWrapper;
  }

  function openPanel() {
    if (!wrapper) return;
    window.clearTimeout(closeTimer);
    wrapper.classList.add('zkr-header-hover--open');
  }

  function closePanel() {
    if (!wrapper) return;
    wrapper.classList.remove('zkr-header-hover--open');
  }

  function togglePanel() {
    if (!wrapper) return;
    if (wrapper.classList.contains('zkr-header-hover--open')) {
      closePanel();
    } else {
      openPanel();
    }
  }

  function replaceWrapperFromSection(sectionHtml) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(sectionHtml, 'text/html');
    var newWrapper = doc.getElementById('zkr-header-bag-wrapper');
    if (!newWrapper || !wrapper) return false;

    wrapper.innerHTML = newWrapper.innerHTML;
    wrapper.className = newWrapper.className;
    wrapper.dataset.sectionId = newWrapper.dataset.sectionId;
    wrapper.removeAttribute('aria-busy');
    setWrapper(wrapper);
    return true;
  }

  function currentLineQuantities() {
    var steppers = wrapper.querySelectorAll('[data-zkr-bag-stepper]');
    return Array.prototype.map.call(steppers, function (stepper) {
      var valueEl = stepper.querySelector('.zkr-header-bag-panel__stepper-value');
      return parseInt(valueEl ? valueEl.textContent : '0', 10) || 0;
    });
  }

  function changeLine(line, quantity) {
    var sectionId = wrapper.dataset.sectionId;

    wrapper.setAttribute('aria-busy', 'true');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: [sectionId],
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.errors || !state.sections || !state.sections[sectionId]) return;

        if (!replaceWrapperFromSection(state.sections[sectionId])) return;
        openPanel();
      })
      .catch(function () {
        wrapper.removeAttribute('aria-busy');
      });
  }

  window.ZakraHeaderBag = {
    getSectionsToRender: function () {
      return [
        {
          id: wrapper.dataset.sectionId,
        },
      ];
    },

    setActiveElement: function () {},

    renderContents: function (parsedState) {
      var sectionId = wrapper.dataset.sectionId;
      if (!parsedState.sections || !parsedState.sections[sectionId]) return;

      wrapper.setAttribute('aria-busy', 'true');
      if (replaceWrapperFromSection(parsedState.sections[sectionId])) {
        openPanel();
      }
    },
  };

  wrapper.addEventListener('click', function (event) {
    var cartLink = event.target.closest('#cart-icon-bubble');
    if (cartLink) {
      event.preventDefault();
      togglePanel();
      return;
    }

    var stepper = event.target.closest('[data-zkr-bag-stepper]');
    if (!stepper) return;

    var line = parseInt(stepper.dataset.line, 10);
    if (!line) return;

    var quantities = currentLineQuantities();
    var currentQuantity = quantities[line - 1] || 0;

    if (event.target.closest('[data-zkr-bag-increase]')) {
      changeLine(line, currentQuantity + 1);
    } else if (event.target.closest('[data-zkr-bag-decrease]')) {
      changeLine(line, Math.max(0, currentQuantity - 1));
    } else if (event.target.closest('[data-zkr-bag-remove]')) {
      changeLine(line, 0);
    }
  });

  wrapper.addEventListener('mouseenter', openPanel);

  wrapper.addEventListener('mouseleave', function () {
    closeTimer = window.setTimeout(closePanel, 120);
  });

  document.addEventListener('click', function (event) {
    if (!wrapper || wrapper.contains(event.target)) return;
    closePanel();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePanel();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initZakraHeaderBag);
} else {
  initZakraHeaderBag();
}

function initZakraHeaderMobilePanels() {
  var mobileQuery = window.matchMedia('(max-width: 989px)');

  function closeOtherPanels(activeWrapper) {
    document.querySelectorAll('[data-zkr-header-hover].zkr-header-hover--open').forEach(function (wrapper) {
      if (wrapper !== activeWrapper) wrapper.classList.remove('zkr-header-hover--open');
    });
  }

  function closeAllPanels() {
    closeOtherPanels(null);
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!mobileQuery.matches) return;

      var trigger = event.target.closest('[data-zkr-header-hover] > a');
      if (!trigger) return;

      var wrapper = trigger.closest('[data-zkr-header-hover]');
      if (!wrapper || !wrapper.querySelector('.zkr-header-panel')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var shouldOpen = !wrapper.classList.contains('zkr-header-hover--open');
      closeOtherPanels(wrapper);
      wrapper.classList.toggle('zkr-header-hover--open', shouldOpen);
    },
    true
  );

  document.addEventListener('click', function (event) {
    if (!mobileQuery.matches || event.target.closest('[data-zkr-header-hover]')) return;
    closeAllPanels();
  });

  mobileQuery.addEventListener('change', function () {
    closeAllPanels();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initZakraHeaderMobilePanels);
} else {
  initZakraHeaderMobilePanels();
}
